// Components
import { Shortcut, ShortcutProvider } from '@shopify/react-shortcuts';

// Constants
import KEYCODES from './constants/shortcuts.keycodes';
export { ShortcutProvider, KEYCODES };
export default Shortcut;